"use client";

import { useResponsive, useApp } from "@/Hooks";

export default function useDoccureVideoModal() {
  const { modal } = useApp();
  const { isMobile } = useResponsive();

  return {
    show: (src: string) => {
      modal.info({
        icon: null,
        title: null,
        footer: [],
        closable: true,
        centered: true,
        width: isMobile ? "100vw" : "80vw",
        styles: {
          body: {
            padding: 0,
          },
        },
        content: (
          <video
            src={src}
            controls
            autoPlay
            playsInline
            preload="metadata"
            style={{ display: "block", width: "100%", maxHeight: "80vh" }}
          />
        ),
      });
    },
  };
}
